const language = {
  UNDEFINED: '未定义',

  AFRIKAANS: '南非荷兰语',
  AMHARIC: '阿姆哈拉语',
  ARABIC: '阿拉伯语',
  MODERN_STANDARD_ARABIC: '现代标准阿拉伯语',

  AZERBAIJANI: '阿塞拜疆语',
  BULGARIAN: '保加利亚语',
  BENGALI: '孟加拉语',
  CATALAN: '加泰罗尼亚语',
  CZECH: '捷克语',
  DANISH: '丹麦语',
  GERMAN: '德语',
  GREEK: '希腊语',

  ENGLISH: '英语',
  AMERICAN_ENGLISH: '英语（美式）',
  BRITISH_ENGLISH: '英语（英式）',

  SPANISH: '西班牙语',
  EUROPEAN_SPANISH: '西班牙语（欧洲）',
  LATIN_AMERICAN_SPANISH: '西班牙语（拉丁美洲）',

  ESTONIAN: '爱沙尼亚语',
  PERSIAN: '波斯语',
  FINNISH: '芬兰语',
  FILIPINO: '菲律宾语',
  FRENCH: '法语',
  CANADIAN_FRENCH: '法语（加拿大）',

  GUJARATI: '古吉拉特语',
  HEBREW: '希伯来语',
  HINDI: '印地语',
  CROATIAN: '克罗地亚语',
  HUNGARIAN: '匈牙利语',
  ARMENIAN: '亚美尼亚语',
  INDONESIAN: '印度尼西亚语',
  ICELANDIC: '冰岛语',
  ITALIAN: '意大利语',
  JAPANESE: '日语',
  GEORGIAN: '格鲁吉亚语',
  KAZAKH: '哈萨克语',
  KHMER: '高棉语',
  KANNADA: '卡纳达语',
  KOREAN: '韩语',
  KIRGHIZ: '吉尔吉斯语',
  LAO: '老挝语',

  LITHUANIAN: '立陶宛语',
  LATVIAN: '拉脱维亚语',

  MACEDONIAN: '马其顿语',
  MALAYALAM: '马拉雅拉姆语',
  MONGOLIAN: '蒙古语',
  MARATHI: '马拉地语',
  MALAY: '马来语',
  BURMESE: '缅甸语',
  NEPALI: '尼泊尔语',

  DUTCH: '荷兰语',

  NORWEGIAN: '挪威语',

  PUNJABI: '旁遮普语',
  POLISH: '波兰语',

  PORTUGUESE: '葡萄牙语',
  BRAZILIAN_PORTUGUESE: '葡萄牙语（巴西）',
  EUROPEAN_PORTUGUESE: '葡萄牙语（葡萄牙）',

  ROMANIAN: '罗马尼亚语',
  RUSSIAN: '俄语',
  SINHALA: '僧伽罗语',
  SLOVAK: '斯洛伐克语',
  SLOVENIAN: '斯洛文尼亚语',
  ALBANIAN: '阿尔巴尼亚语',
  SERBIAN: '塞尔维亚语',
  SERBIAN_LATIN: '塞尔维亚语（拉丁字母）',

  SWEDISH: '瑞典语',
  SWAHILI: '斯瓦希里语',

  TAMIL: '泰米尔语',
  TELUGU: '泰卢固语',
  THAI: '泰语',
  TURKISH: '土耳其语',

  UKRAINIAN: '乌克兰语',
  URDU: '乌尔都语',

  UZBEK: '乌兹别克语',
  VIETNAMESE: '越南语',
  CHINESE: '中文',
  SIMPLIFIED_CHINESE: '中文（简体）',
  TRADITIONAL_CHINESE: '中文（繁体）',

  ZULU: '祖鲁语'
};

export default language;
